module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/051cc58724149226b23311d799c1c144.png";